<template>
	<div
		@click="goToLearningLesson()"
		:class="[
			'e-learning-box',
			{ 'e-learning-box-finished': isSectionDone },
			isTestReady,
		]"
	>
		<span class="section-number">{{
			id !== 0 ? 'sekcja ' + id : 'Test wiedzy'
		}}</span>
		<span class="e-learning-icon">
			<img :src="showIcon" />
		</span>
		<h2 :class="{ 'test-is-ready': id === 0 && isTest }">{{ name }}</h2>
		<div class="e-learnig-info">
			<!-- Gdy nie wszystkie lekcje w danej sekcji zostały ukończone -->
			<div v-if="!isSectionDone && id !== 0">
				<span>
					<b>{{ finishedLessons }} / {{ movies.length }}</b> lekcji
					ukończyłeś
				</span>
				<span>
					pozostało:
					<b>{{ lessonsTime }}</b>
				</span>
			</div>
			<!-- Gdy wszystkie lekcje w danej sekcji zostały ukończone -->
			<div v-else-if="isSectionDone && !isTest">
				<span>Ukończyłeś wszystkie lekcje!</span>
			</div>
			<!-- Jeżeli okienko z testem -->
			<template v-else>
				<div v-if="id === 0 && !isTest">
					<span>{{ cms.beforeTest }}</span>
				</div>
				<!-- Jeżeli okienko z testem i wszystkie kursy zostały ukończone -->
				<template v-else-if="id === 0 && isTest">
					<div v-if="!testMessage">
						<span class="info-hide-mobile">{{ cms.info[0] }}</span>
					</div>
					<div class="mt-3">
						<span v-if="!testMessage">{{ cms.info[1] }}</span>
						<span v-else class="text-danger mb-2 error-message">{{
							testMessage
						}}</span>
						<button
							class="btn btn-primary"
							@click.prevent="startQuiz()"
						>
							rozpocznij
						</button>
					</div>
				</template>
			</template>
		</div>
		<span
			v-if="!isSectionDone && !isTest"
			class="e-learning-bar"
			:style="{
				width: calculatedWidth(finishedLessons, movies.length) + '%',
			}"
		></span>
	</div>
</template>
<script>
import { eLearningLessons } from '@/mixins/e-learning.js';
export default {
	props: {
		id: {
			type: Number,
			required: false,
			default: 0,
		},
		name: {
			type: String,
			required: true,
			default: '',
		},
		movies: {
			type: Array,
			required: false,
			default: () => [],
		},
		finishedLessons: {
			type: Number,
			required: false,
			default: 1,
		},
		lessonsTime: {
			type: String,
			required: false,
			default: '',
		},
		icon: {
			type: String,
			required: false,
			default: '',
		},

		isTestReady: {
			type: String,
			required: false,
			default: '',
		},
	},
	data() {
		return {
			cms: {
				/* eslint-disable */

				info: ELEARNING_READY_TEST,
				beforeTest: ELEARNING_BEFORE_TEST,
			},
		};
	},
	mixins: [eLearningLessons],
	computed: {
		isSectionDone() {
			return this.finishedLessons === this.movies.length ? true : false;
		},
		showIcon() {
			return !this.isSectionDone
				? 'images/learning/' + this.icon
				: this.id === 0
				? 'images/learning/test.svg'
				: 'images/statusPage/ty-success.png';
		},
		isTest() {
			return this.isTestReady === 'e-learning-box-success' ? true : false;
		},
		testMessage() {
			return this.$store.getters.getTestMessage;
		},
	},
	methods: {
		async goToLearningLesson() {
			if (this.id === 0) return;
			let time = this.movies[0].time;
			let timeParts = time.split(':');
			time =
				timeParts[0] * 3600000 +
				timeParts[1] * 60000 +
				timeParts[2] * 1000 +
				300000;

			// this.$store.dispatch('fetchLogOutTimer', time);
			const now = new Date();
			// const expirationDate = new Date(now.getTime() + time);
			// sessionStorage.setItem('expirationDate', expirationDate);
			let movieTime = new Date(now.getTime() + time);

			let expirationDate = new Date(
				now.getTime() + this.$store.getters.getTimeToLogout
			);

			this.$store.dispatch(
				'fetchLogOutTimer',
				this.$store.getters.getTimeToLogout
			);
			sessionStorage.setItem('expirationDate', expirationDate);

			let selected = {
				id: this.id,
				name: this.name,
				movieName: this.movies[0].name,
				movieSrc: this.movies[0].src,
				movieId: this.movies[0].id,
				movieTime: movieTime,
			};
			this.$store.commit('setSelectedVideo', selected);
			this.$store.dispatch('generateToken');
			this.$router.push('/eLearningCourses');
		},
		startQuiz() {
			this.$store.dispatch('fetchQuizTime');
		},
	},
};
</script>
